<h1 class="pb-4 self-start text-2xl font-semibold">Switch User</h1>
<mat-dialog-content>
  <form [formGroup]="switchUserForm" class="flex flex-col gap-4 p-4">
    <mat-form-field appearance="outline">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" placeholder="Enter username">
      <mat-error *ngIf="switchUserForm.get('username')?.hasError('required')">
        Username is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input matInput type="password" formControlName="password" placeholder="Enter password">
      <mat-error *ngIf="switchUserForm.get('password')?.hasError('required')">
        Password is required
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="!switchUserForm.valid">
    Login
  </button>
</mat-dialog-actions> 